import { useQuery } from "@/api/utils/useQuery"
import { HasuraQueries } from "@/api/hasura/queries"
import {
  GetEmailsByEmailAddressQuery,
  GetEmailContentQuery,
} from "@/api/hasura/generated/graphql"
import { ICommunicationsEmail } from "@/models/communicationsEmail/communicationsEmail.type"
import {
  CommunicationsEmailParser,
  ICommunicationsEmailRaw,
} from "@/models/communicationsEmail/communicationsEmail.parser"

export interface IEmailMessage {
  id: number
  subject?: string
  processed_at?: string
  opened: boolean
  html_content?: string
}

export interface IEmail {
  email_message?: IEmailMessage
}

const parseEmailsQuery = (
  data?: GetEmailsByEmailAddressQuery,
): ICommunicationsEmail[] => {
  if (!data) return []
  return data.recipients
    .map((email) => {
      return CommunicationsEmailParser.toDomain(
        email.email_message as ICommunicationsEmailRaw,
      )
    })
    .filter((email) => {
      return email.dateDelivered.isValid() && email.subject
    })
}

const parseEmailQuery = (data?: GetEmailContentQuery): string | undefined => {
  return data?.getEmailContent?.emailBody
}

class CommunicationsServiceClass {
  getEmails(email?: string) {
    return useQuery({
      ...HasuraQueries.comms.emails(email ?? ""),
      placeholderData: [],
      useRawResponse: true,
      enabled: !!email,
      parserFn: (data) => parseEmailsQuery(data),
    })
  }

  getEmailContent(path: string) {
    return useQuery({
      ...HasuraQueries.comms.emailContent(path),
      useRawResponse: true,
      parserFn: (data) => parseEmailQuery(data),
    })
  }
}

export const CommunicationsService = new CommunicationsServiceClass()
